import React, { useState } from 'react';
import {
  IMAGE_CDN_HOST_DEV,
  IMAGE_CDN_HOST_PROD,
  IMAGE_STORE_HOST_DEV,
  SHOW_IMAGE_CONSTANTS,
} from '../../config/constants';
import { ImageType } from '../../data/types/files';
import { defaultPlaceholderEmptyImage_path } from '../../assets/index';

enum OptimizeFor {
  Thumbnail,
  ProductGallery,
  FullResolution,
}

type ShowImageProps = {
  image?: ImageType;
  imageSrc?: string;
  classNames?: string;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
};

export default function ShowImage({
  image,
  imageSrc,
  classNames,
  style,
  onClick,
}: ShowImageProps) {
  const [error, setError] = useState(false);
  const url =
    image?.public_s3_url || image?.get_object_presigned_url || imageSrc || '';

  const getCdnUrl = (raw_url: string, optimizeFor: OptimizeFor): string => {
    // TODO set default optimizeFor or required
    if (raw_url.includes('X-Amz-Credential')) {
      // image is private and should not be cached in the CDN
      return raw_url;
    }
    try {
      const raw_uri = new URL(raw_url);

      if (raw_uri.host === IMAGE_STORE_HOST_DEV) {
        raw_uri.host = IMAGE_CDN_HOST_DEV;
        raw_uri.searchParams.set('class', OptimizeFor[optimizeFor]);
        return raw_uri.toString();
      } else if (raw_uri.host === IMAGE_CDN_HOST_PROD) {
        raw_uri.host = IMAGE_CDN_HOST_PROD;
        raw_uri.searchParams.set('class', OptimizeFor[optimizeFor]);
        return raw_uri.toString();
      }

      // not silal's image store URL
      return raw_url;
    } catch (e) {
      return raw_url;
    }
  };
  return error ? (
    <img
      src={defaultPlaceholderEmptyImage_path}
      alt={image?.alt || 'image'}
      className={classNames}
      onClick={onClick}
      style={{
        ...style,
        width: style?.width || SHOW_IMAGE_CONSTANTS.IMAGE_WIDTH,
        height: style?.height || SHOW_IMAGE_CONSTANTS.IMAGE_HEIGHT,
        borderRadius: style?.borderRadius || 'none',
        objectFit: style?.objectFit || 'contain',
        objectPosition: style?.objectPosition || 'center',
      }}
    />
  ) : (
    <img
      src={getCdnUrl(url, OptimizeFor.ProductGallery)}
      alt={image?.alt || 'image'}
      className={classNames}
      onClick={onClick}
      onLoad={() => setError(false)}
      onError={() => setError(true)}
      style={{
        ...style,
        width: style?.width || SHOW_IMAGE_CONSTANTS.IMAGE_WIDTH,
        height: style?.height || SHOW_IMAGE_CONSTANTS.IMAGE_HEIGHT,
        borderRadius: style?.borderRadius || 'none',
        objectFit: style?.objectFit || 'contain',
        objectPosition: style?.objectPosition || 'center',
      }}
    />
  );
}
